<button (click)="preview()">
  <document-pill [filename]="name"></document-pill>
</button>
